import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";

export default function P302Chart2({ data }) {
    const [show, setShow] = useState(false);
    const dataConf = {
        series: [
            {
                name: "ประมาณการ",
                data: data.valList1,
                // data: [28, 25, 33, 36, 32, 32, 33],
            },
            {
                name: "เบิกจริง",
                data: data.valList2,
                // data: [12, 25, 14, 18, 17, 13, 13],
            },
        ],
        options: {
            chart: {
                //   height: 350,
                type: "line",
                zoom: {
                    enabled: false,
                },
                animations: {
                    enabled: false,
                },
                toolbar: {
                    show: false,
                },
            },
            // colors: ['#77B6EA', '#545454'],
            dataLabels: {
                enabled: true,
            },
            stroke: {
                curve: "smooth",
            },
            grid: {
                borderColor: "#e7e7e7",
                row: {
                    colors: ["#f3f3f3", "transparent"],
                    opacity: 0.5,
                },
            },
            markers: {
                size: 1,
            },
            xaxis: {
                  categories: data.seriesList
                // categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"],
            },
            yaxis: {},
            legend: {
                show: true,
                position: "top",
                horizontalAlign: "right",
                floating: true,
                offsetX: 0,
                offsetY: -5,
            },
        },
    };

    useEffect(() => {
        if (data) {
            setShow(true);
        }
    }, [data]);

    return (
        <div>
            <div className="card" style={{ height: "auto" }}>
                <h2 className="centerText" style={{ textAlign: "center" }}>
                    ประมาณการเบิกจ่ายและเบิกจ่ายจริง (ล้านบาท)
                </h2>

                {show === true ? <Chart options={dataConf.options} series={dataConf.series} type="line" height="350" /> : ""}
            </div>
        </div>
    );
}
